<template>
  <div>
    <common-sur-header />
    <common-header
        :nav-items="header.navItems"
        :cta-buttons="header.ctaButtons"
    />
    <pro-services-header text="Livraison de véhicules neufs, d’occasion ou de location en France et en Europe" :icon-url="require('../../img/valet.png')"/>
    <div class="pro-services-intro-container">
      <p class="intro-text isidorasansalt-semi-bold-magic-potion-16px">La livraison de véhicules neufs, d’occasion ou de location en France et en Europe constitue l’un des piliers du service de <a href="/popvalet-pro-services-valet" style="color: #002244">transport par Valet</a> orchestré par Pop Valet. En 24 heures seulement, nos quelque 2 500 chauffeurs assurent la livraison de tous vos véhicules à vos clients, les professionnels comme les particuliers, à l’adresse indiquée grâce à notre solution numérique.
        Concrètement, comment se passe la livraison de votre véhicule ? À quels types de professionnels s’adresse ce service ? Pourquoi choisir la solution Pop Valet ?
        Nos équipes vous répondent.
      </p>
    </div>
    <div class="pro-services-livraison-container">
      <h2 class="isidorasansalt-bold-white-28px">La livraison de votre véhicule neuf, d’occasion ou de location</h2><br>
      <p class="isidorasansalt-semi-bold-white-18px">Nos Valets assurent la livraison de toutes vos voitures, vos petits ou gros utilitaires (jusqu’à 20m3), vans, camping-cars, voitures sans permis... Vous pouvez :</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Faire livrer un véhicule neuf (VN)</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Faire livrer un véhicule d’occasion (VO)</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Faire livrer un véhicule de location (VLOC)</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">Dans chaque configuration, un chauffeur récupère votre véhicule et le livre à votre client professionnel ou particulier.</p>
    </div>
    <div class="pro-services-livraison-pro-particulier-container">
      <h2 class="isidorasansalt-bold-magic-potion-28px">La livraison de voitures pour tous les professionnels et les particuliers</h2><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">Riche de son ADN tourné tant vers le B2B (business to business) que vers le B2C (business to consumer), Pop Valet livre vos véhicules aussi bien à des professionnels qu’à des particuliers, sur l’ensemble de la France métropolitaine et de la Corse. Nos services s’adressent à vous si :</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Vous êtes loueur de courte durée : vous avez loué une voiture à la journée, à la semaine, au mois ou à l’année</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Vous êtes loueur de longue durée : vous avez loué une voiture à longue durée (LLD) ou avec option d’achat (LOA)</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Vous êtes concessionnaire automobile : vous êtes juridiquement indépendant et exercez soit en exclusivité avec une marque automobile, soit en multimarque</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Vous êtes constructeur automobile : l’activité de votre entreprise est la conception, la construction et, in fine, la commercialisation de voitures</p>
    </div>
    <div class="pro-services-livraison-avantages-container">
      <h2 class="isidorasansalt-bold-white-28px">Les avantages du service de livraison de véhicules Pop Valet</h2><br>
      <p class="isidorasansalt-semi-bold-white-18px">Sa réputation d’excellence, Pop Valet l’a bâtie sur une série d’atouts. Couverture géographique nationale et continentale, assurances et garanties, technologies de pointe, Valets triés sur le volet et partenaires de prestige : découvrez la plus-value de notre service de livraison automobile.</p><br>

      <h3 class="isidorasansalt-bold-white-24px">Une couverture géographique de la France et de l’Europe</h3><br>
      <p class="isidorasansalt-semi-bold-white-18px">Pop Valet, c’est un maillage dense sur l’ensemble du territoire français, avec des implantations locales et physiques dans les principales agglomérations. Nous opérons sur des distances sans limitation pouvant couvrir de quelques kilomètres à plusieurs milliers.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Votre livraison de véhicule depuis et vers la France métropolitaine</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Notre service de livraison de voiture à domicile ou sur le lieu de travail est assuré dans chacun des 96 départements de France métropolitaine.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Votre livraison de véhicule depuis et vers la Corse</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Notre transport de véhicules inclut également les deux départements corses : la Haute-Corse et la Corse-du-Sud. Nous appliquons à la région insulaire une tarification personnalisée avec majoration.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Votre livraison de véhicule depuis et vers l’Europe</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Notre transport de voitures via Valet est également assuré dans les pays de l’Union européenne avec un départ ou une arrivée en France.</p><br>

      <h3 class="isidorasansalt-bold-white-24px">Des assurances et des garanties pour votre véhicule</h3><br>
      <p class="isidorasansalt-semi-bold-white-18px">Pop Valet est responsable du véhicule pendant toute la durée du transport, de sa prise en charge jusqu’à sa livraison effective. Le transfert de responsabilité est matérialisé par l’état des lieux et concerne toutes les infractions potentielles et éventuels sinistres.</p><br>

      <h3 class="isidorasansalt-bold-white-24px">Des outils technologiques performants</h3><br>
      <p class="isidorasansalt-semi-bold-white-18px">L’objectif de la technologie développée et exploitée par Pop Valet ? Vous faire gagner du temps à chaque véhicule livré et vous soulager de la paperasse.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Un formulaire simple pour tous les professionnels</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Pour activer votre livraison, il vous suffit de renseigner sur notre site internet :<p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Les adresses de départ et d’arrivée<p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- La date</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Le véhicule</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">Quelques minutes seulement suffisent.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Un état des lieux digitalisé</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Deux états des lieux sont systématiquement émis à chaque transport :<p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Un premier au départ du véhicule<p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Un second, complet et non contradictoire, à son arrivée</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">Accusé de réception, état des lieux : tous les documents inhérents à la livraison de votre véhicule sont scannés puis vous sont envoyés.</p><br>

      <h3 class="isidorasansalt-bold-white-24px">Des Valets triés sur le volet</h3><br>
      <p class="isidorasansalt-semi-bold-white-18px">Les chauffeurs à qui nous confions vos véhicules sont choisis à l’issue d’un processus de recrutement exigeant et sont notés par vos soins à l’aune de leur prestation. Nos Valets doivent tous justifier :</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- De 3 ans de permis</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- De 8 points au minimum</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- D’une expérience significative de la conduite</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">Ils sont soumis à :</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Un entretien vidéo</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Une formation théorique</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">- Une formation pratique</p><br>
      <p class="isidorasansalt-semi-bold-white-18px">Seuls 4 % de nos candidats valident le processus dans son intégralité. Enfin, c’est votre client qui, une fois le véhicule livré, évalue la qualité de la prestation et, avec elle, délivre son avis sur le chauffeur.</p>

      <h3 class="isidorasansalt-bold-white-24px">Des partenaires de prestige</h3><br>
      <p class="isidorasansalt-semi-bold-white-18px">De Tesla à Emil Frey, ils nous accompagnent au quotidien dans nos prestations de livraisons par la route.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Le constructeur automobile Tesla</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Le constructeur 100 % électrique a mis en place un partenariat avec Pop Valet afin que ses équipes France puissent proposer la livraison à domicile de chaque véhicule à ses clients.</p><br>
      <h4 class="isidorasansalt-bold-white-20px">Le groupe suisse Emil Frey</h4><br>
      <p class="isidorasansalt-semi-bold-white-18px">Le premier distributeur automobile européen fait confiance à Pop Valet pour ses livraisons de VN, VO et véhicules de loueurs, mais également pour la prise en charge de véhicules vers ses ateliers sur tout le territoire français.</p><br>
    </div>
    <div class="pro-services-livraison-additionnel-services-container">
      <h2 class="isidorasansalt-bold-magic-potion-28px">Au-delà de votre livraison de véhicule : nos services additionnels</h2><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">Découvrez quelques-uns des services optionnels pouvant être intégrés aux livraisons assurées par Pop Valet :</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Lavage intérieur et extérieur du véhicule : votre véhicule est livré propre, dehors comme dedans (programmes à brosses, haute pression, lavage à la main…)</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Remise à niveau de carburant : votre véhicule thermique ou hybride est livré avec le même niveau d’essence qu’au départ ou avec le plein du réservoir selon votre souhait</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Recharge électrique : votre véhicule électrique ou hybride est livré rechargé (le temps de charge est pris en compte dans la tarification)</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Contrôle simple du véhicule : votre véhicule est soumis à une évaluation sommaire (fluides, pneumatiques, éclairages, pare-brise, confort…)</p><br>
    </div>
    <div class="pro-services-livraison-plus-loin-container">
      <h2 class="isidorasansalt-bold-magic-potion-28px">Aller plus loin avec Pop Valet</h2><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">Du convoyage au jockeyage, découvrez les autres solutions de mobilité proposées par Pop Valet :</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Rendez-vous sur notre service de <a href="/popvalet-pro-services-valet-convoyage" style="color: #002244">convoyage de véhicules</a> si vous avez besoin de transporter par la route une ou plusieurs voitures entre deux lieux définis ou pour des besoins internes</p><br>
      <p class="isidorasansalt-semi-bold-magic-potion-18px">- Rendez-vous sur notre service de <a href="/popvalet-pro-services-valet-jockeyage" style="color: #002244">jockeyage de véhicules</a> si vous êtes en quête d’un service de conciergerie automobile pour emmener une voiture vers tout acte d’entretien ou de réparation</p>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import CommonHeader from "@/components/common/CommonHeader";
import CommonSurHeader from "@/components/common/CommonSurHeader";
import ProServicesHeader from "@/components/ProServicesHeader";
import CommonFooter from "@/components/common/CommonFooter";

export default {
  name: "PopValetProServicesValetLivraison",
  components: {
    CommonHeader,
    CommonSurHeader,
    ProServicesHeader,
    CommonFooter,
  },
  props: [
    'header',
  ],
  metaInfo: {
    title: 'Livraison de Véhicules Neufs, Occasion, Location | Pop Valet',
    meta: [
      { name: 'description', content: 'En 24 heures, nos chauffeurs assurent la livraison de tous vos véhicules neufs, d’occasion ou de location à vos clients professionnels ou particuliers.' },
    ]
  }
}
</script>

<style scoped>
.pro-services-livraison-plus-loin-container h2 {
  margin-bottom: 30px;
  text-align: center;
}
.pro-services-livraison-plus-loin-container {
  background-color: var(--grisclair);
  padding: 100px 150px;
  line-height: 29px;
}
.pro-services-livraison-additionnel-services-container h2 {
  margin-bottom: 30px;
  text-align: center;
}
.pro-services-livraison-additionnel-services-container {
  padding: 100px 150px;
  line-height: 29px;
}
.pro-services-livraison-avantages-container h4 {
  margin-top: 15px;
}
.pro-services-livraison-avantages-container h3 {
  margin-top: 25px;
}
.pro-services-livraison-avantages-container h2 {
  margin-bottom: 30px;
  text-align: center;
}
.pro-services-livraison-avantages-container {
  background-color: var(--bluenavy);
  padding: 100px 150px;
  line-height: 29px;
}
.pro-services-livraison-pro-particulier-container h2 {
  margin-bottom: 30px;
  text-align: center;
}
.pro-services-livraison-pro-particulier-container {
  padding: 100px 150px;
  line-height: 29px;
}
.pro-services-livraison-container h2 {
  margin-bottom: 30px;
  text-align: center;
}
.pro-services-livraison-container {
  background-color: var(--bluenavy);
  padding: 100px 150px;
  line-height: 29px;
}
.intro-text {
  max-width: 1000px;
  margin: auto;
  letter-spacing: 0;
  line-height: 28.8px;
  text-align: center;
  padding: 0 20px;
}
.pro-services-intro-container {
  width: 100%;
  margin-top: 80px;
  margin-bottom: 80px;
}

@media screen and (max-width: 991px) {
  .pro-services-livraison-plus-loin-container {
    padding: 100px 50px;
  }
  .pro-services-livraison-additionnel-services-container {
    padding: 100px 50px;
  }
  .pro-services-livraison-avantages-container {
    padding: 100px 50px;
  }
  .pro-services-livraison-pro-particulier-container {
    padding: 100px 50px;
  }
  .pro-services-livraison-container {
    padding: 100px 50px;
  }
}
</style>